<template>
  <div class="content">
    <h1>TARGET ACCOUNTS</h1>
    <ul>
      <li>
        Automotive: Short/long lead press or launch events – garden and ballroom
        can accommodate car displays
      </li>
      <li>
        Tech: Cisco, Dell, new startups – unique open space appeals to the
        aesthetic of this attendee profile
      </li>
      <li>
        Financial: Bain, Band of America, Morgan Stanley
      </li>
      <li>
        Legal: Society Level can be segmented including 10 guest rooms, Council
        Boardroom, hospitality room, and Society Ballroom as war room
      </li>
      <li>
        Cosmetic | Design | Fashion: L’Oreal, Chanel, Fashion Brands, Pharma
        investigator meetings
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Target"
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
h1 {
  font: normal 27px/32px $courier;
  letter-spacing: 0.27px;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

ul {
  padding-inline-start: 1rem;
}

li {
  font: normal 18px/25px $caslon;
  letter-spacing: 0;
  color: $black;
  margin: 1rem 0;
}
</style>
